<template>
  <div>
    <h2 class="c-title">{{ $t('pages.CompaniesVisitorStoreEdit.pagePreview.sns.title') }}</h2>
    <ul class="p-sns">
      <li v-show="isDisplayFacebook && facebookUrl" class="p-sns__item">
        <div class="p-sns__icon p-sns__icon--facebook">
          <img alt="" :src="iconFacebookPath">
        </div>
        <p class="p-sns__name">Facebook</p>
        <a class="p-sns__button" target="_blank" :href="facebookUrl">{{ $t('labels.check') }}</a>
      </li>
      <li v-show="isDisplayTwitter && twitterUrl" class="p-sns__item">
        <div class="p-sns__icon p-sns__icon--twitter">
          <img alt="" :src="iconTwitterPath">
        </div>
        <p class="p-sns__name">X</p>
        <a class="p-sns__button" target="_blank" :href="twitterUrl">{{ $t('labels.check') }}</a>
      </li>
      <li v-show="isDisplayInstagram && instagramUrl" class="p-sns__item">
        <div class="p-sns__icon p-sns__icon--instagram">
          <img alt="" :src="iconInstagramPath">
        </div>
        <p class="p-sns__name">Instagram</p>
        <a class="p-sns__button" target="_blank" :href="instagramUrl">{{ $t('labels.check') }}</a>
      </li>
      <li v-show="isDisplayLine && lineUrl" class="p-sns__item">
        <div class="p-sns__icon p-sns__icon--line">
          <img alt="" :src="iconLinePath">
        </div>
        <p class="p-sns__name">LINE</p>
        <a class="p-sns__button" target="_blank" :href="lineUrl">{{ $t('labels.check') }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import iconFacebookPath from '../../../images/common/icon_facebook.svg'
import iconInstagramPath from '../../../images/common/icon_instagram.svg'
import iconLinePath from '../../../images/common/icon_line.svg'
import iconTwitterPath from '../../../images/common/icon_x.svg'

export default {
  name: 'SNS',
  props: {
    facebookUrl: String,
    twitterUrl: String,
    instagramUrl: String,
    lineUrl: String,
    isDisplayFacebook: {
      type: Boolean,
      required: true,
    },
    isDisplayTwitter: {
      type: Boolean,
      required: true,
    },
    isDisplayInstagram: {
      type: Boolean,
      required: true,
    },
    isDisplayLine: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      iconFacebookPath,
      iconInstagramPath,
      iconLinePath,
      iconTwitterPath,
    }
  },
}
</script>

<style lang="scss" scoped>
.c-title {
  $root: #{&};
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 14px;
  line-height: 1.71;
}

.p-sns {
  $root: #{&};
  padding: 0 24px;
  border-radius: 10px;
  background-color: #F4F4F4;
  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 0;
    &:not(:first-child) {
      border-top: 1px solid #E6EBF0;
    }
  }
  &__icon {
    display: flex;
    flex-basis: 40px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    &--facebook {
      width: 10px;
      background-color: #3856A2;
    }
    &--twitter {
      width: 18px;
      background-color: #000;
    }
    &--instagram {
      width: 22px;
      background: radial-gradient(99.11% 99.11% at 26.56% 107.7%, #FD5 0%, #FD5 10%, #FF543E 50%, #C837AB 100%);
    }
    &--line {
      width: 24px;
      background-color: #00B900;
    }
  }
  &__name {
    font-weight: bold;
    font-size: 14px;
    line-height: 1.71;
    &:not(:first-child) {
      margin-left: 16px;
    }
  }
  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 98px;
    height: 34px;
    margin-left: auto;
    padding: 0 24px 1px;
    border-radius: 17px;
    background-color: #ECECEC;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
    text-decoration: none;
    white-space: nowrap;
    transition: .2s;
    &:hover {
      background-color: darken(#ECECEC, 5%);
    }
  }
}

</style>
